import CommonImage from '@/components/common/image/CommonImage'
import Link from 'next/link'
import React from 'react'

export default function BranchCard({ title, number1, number2='', number3='',slug }) {
  return (
    <div className='branch-card'>
        <div className="branch-header">
            <h2 className="title">
                <span className="w-6 md:w-8 h-6 md:h-8"><CommonImage src={'./images/home-page/branch-location-icon.avif'} className="img-icon" alt="icon" /> </span> {title}
            </h2>
        </div>
        <div className='content-part'>
            <div className="number">
                <span className="block"><CommonImage src={'./images/home-page/call.avif'} className="img-icon" alt="icon" /> </span> <span className="number_text">{number1}</span>
            </div>
            <div className="number">
                <span className="block"><CommonImage src={'./images/home-page/call.avif'} className="img-icon" alt="icon" /> </span> <span className="number_text">{number2}</span>
            </div>
            <Link href={`/branches/${slug}`} className="branch-btn">
            <CommonImage src={'./images/home-page/branch-btn-icon.avif'} className="img-icon" alt="icon" /> <span className="mt-1">লোকেশন দেখো</span></Link>
        </div>
    </div>
  )
}
